module.exports = __webpack_public_path__ + "assets/img/media-world-news-network.8ab3f259.svg";